module.exports = __webpack_public_path__ + "img/img8.ed757910.png";